import { render, staticRenderFns } from "./PgaBusinessStartupCustomerOrderTable.vue?vue&type=template&id=a546d540&"
import script from "./PgaBusinessStartupCustomerOrderTable.vue?vue&type=script&lang=ts&"
export * from "./PgaBusinessStartupCustomerOrderTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a546d540')) {
      api.createRecord('a546d540', component.options)
    } else {
      api.reload('a546d540', component.options)
    }
    module.hot.accept("./PgaBusinessStartupCustomerOrderTable.vue?vue&type=template&id=a546d540&", function () {
      api.rerender('a546d540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/business-startups/customer-orders/components/table/PgaBusinessStartupCustomerOrderTable.vue"
export default component.exports